// extracted by mini-css-extract-plugin
module.exports = {"container":"DetalharAtualizacao_container__2uoJr","toolBar":"DetalharAtualizacao_toolBar__3JevG"};